import React from "react";
import "../css/dashboard.css";
import { IconButton } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import { useMediaQuery } from "react-responsive";
import { useNavigate } from "react-router-dom";
import NoMobileView from "./NoMobileView";
import SupportDashboardContent from "./SupportDashboardContent";

export default function SupportDashboard() {
  const navigate = useNavigate();

  const handleMenuOpen = () => {
    navigate("/menumobile");
  };

  const isMobile = useMediaQuery({ query: "(max-width: 800px)" });

  return (
    <div className="main-container">
      {isMobile ? (
        <>
          <div className="menu-button-container">
            <IconButton
              edge="start"
              color="inherit"
              aria-label="menu"
              onClick={handleMenuOpen}
              className="menu-button"
            >
              <MenuIcon />
            </IconButton>
          </div>

          <NoMobileView title="Support Dashboard" />
        </>
      ) : (
        <>
          {/* <Navbar2 linkActive={13} /> */}
          <SupportDashboardContent />
        </>
      )}
    </div>
  );
}
